<template>
  <div>
    <!-- 头部 -->
    <!-- <div class="header_top">
      <div class="w">
        logo
        <div class="logo">
          <img src="../../assets/img/login/logo_u6.png" alt="" />
        </div>
        二维码
        <div class="ewm_box">
          <div class="ewm">
            <div>扫码关注我</div>
            <img src="../../assets/img/login/img1.png" alt="" />
          </div>
          <div class="ewm">
            <div>扫码下载APP</div>
            <img src="../../assets/img/login/img1.png" alt="" />
          </div>
        </div>
      </div>
    </div> -->
    <!-- 底部 -->
    <div v-if="loginPage" class="footer_btm">
      <div style="display: flex">
        <div class="q">
          <img src="../../assets/img/login/yx1.png" style="width: 100px; height: 100px;"/>
          <span class="mai">扫码下载app</span>
        </div>
        <div class="teach">
<!--          {{siteName}} 版权所有-->
        </div>
          <a :href="'/admin'" style="text-decoration: none;color: blue;margin-top: 30px; margin-left: 10px">
              管理端</a>
          <!--<router-link to="domains +">管理端</router-link>-->

<!--        <div class="teach1">-->
<!--          <br/>-->
<!--          <a :href="'https://beian.miit.gov.cn/'">-->
<!--            京ICP备16009778号</a>-->

<!--        </div>-->
      </div>
    </div>
    <div v-else class="footer_btm2">
      <div>
        <div>
          <!-- 版权所有 河南财经财经政法大学继续教育学院<br /> -->
<!--          中政网络科技（北京）有限公司 技术支持-->
<!--          河南致远教育科技有限公司 技术支持-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {getSiteId} from "../../assets/js/api.js";
export default {
  data() {
    return {
      loginPage: true,
        siteName: undefined,
        domains: undefined
    };
  },
  mounted() {
      this.domains = document.domain
      this.getSite()
    console.log(this.$route.path);
    if (this.$route.path == "/login") {
      this.loginPage = true;
    } else {
      this.loginPage = false;
    }
  },
    methods: {
        getSite() {
            // getSiteId('smxshglxy.hnzkw.org.cn').then((res) => {
            getSiteId(document.domain).then((res) => {

                this.siteName = res.data.siteName

            });
        },
    }
};
</script>
<style lang="less" scoped>
.w {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header_top {
  width: 100%;
  height: 80px;
  background-color: #fff;
  .logo {
    img {
      width: 540px;
      height: 67px;
    }
  }
  .ewm_box {
    display: flex;
    align-items: center;
    font-size: 12px;
    > div:nth-child(1) {
      margin-right: 40px;
    }
    .ewm {
      display: flex;
      align-items: center;
      div {
        -webkit-writing-mode: vertical-rl;
        writing-mode: vertical-rl;
      }
      img {
        width: 70px;
        height: 70px;
        margin-left: 13px;
      }
    }
  }
}
.footer_btm {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  //height: 196px;
  height: 160px;
  /*line-height: 100px;*/
  /*text-align: center;*/
  background-color: rgba(235, 235, 240, 0.87);
  /*border-top: 1px solid #eaeaea;*/
  font-size: 14px;
  color: #666;
  padding-top: 0px;
  // box-sizing: border-box;
  .q {
    margin-top: 30px;
    margin-left: 60px;
    .mai {
      display: block;
    }
  }
  .teach {
    height: 80px;
    line-height: 80px;
    font-size: 12px;
    float: left;
    margin-left: 10px;
  }
  .teach1 {
    height: 80px;
    line-height: 80px;
    font-size: 12px;
    float: left;
    margin-left: 400px;
  }

}
.footer_btm2 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 140px;
  text-align: center;
  // background-color: #029aff;
    border-top: 1px solid #ff4939;
  font-size: 14px;
  color: #fff;
  line-height: 130px;
  padding-top: 10px;
  box-sizing: border-box;
  > div {
    height: 130px;
      background-color: #ff551b;
    width: 100%;
    > div {
      display: inline-block;
      line-height: 30px; /*单独给子元素设置行高，覆盖父级元素的行高*/
      vertical-align: middle; /*基线居中对齐*/
    }
  }
}
</style>
